import { Icon } from '@scale/scaleui';
import { useCurrentEditor } from '@tiptap/react';
import useIsEditorEditable from '../../hooks/useIsEditorEditable';
export function UndoButton() {
  const { editor } = useCurrentEditor();
  const isEditable = useIsEditorEditable();

  if (!editor) return null;

  return (
    <div className="p-2">
      <Icon
        tooltip="Undo"
        tooltipProps={{
          delayDuration: 0,
        }}
        onClick={() => editor.chain().focus().undo().run()}
        icon="undo"
        size="sm"
        disabled={!editor.can().undo() || !isEditable}
      />
    </div>
  );
}
export function RedoButton() {
  const { editor } = useCurrentEditor();
  const isEditable = useIsEditorEditable();

  if (!editor) return null;

  return (
    <div className="p-2">
      <Icon
        tooltip="Redo"
        tooltipProps={{
          delayDuration: 0,
        }}
        onClick={() => editor.chain().focus().redo().run()}
        icon="redo"
        size="sm"
        disabled={!editor.can().redo() || !isEditable}
      />
    </div>
  );
}
